import { showModal, clearModal } from 'actions';
import { startProgram } from 'actions/Broadcast';
import { AWAITING_KNOCK_APPROVAL } from 'constants/ModalTypes';
import { BROADCAST_JOIN_MEETING } from '../Types';
import { getCurrentBroadcast } from '@shoflo/studio-redux/actions';
import { createConfiguration } from '@studio/chime/configuration/createConfiguration';
import { addDeviceEventObserverToSession } from '@studio/chime/observers/addDeviceEventObserverToSession';

function joinMeeting({
  meetingResponse,
  attendeeResponse,
  mixerAttendeeIds,
  chatToken,
  hasChatAccess
}) {
  return dispatch => {
    const { meetingSession } = createConfiguration(
      meetingResponse,
      attendeeResponse
    );

    addDeviceEventObserverToSession(dispatch, showModal, meetingSession);

    const action = {
      type: BROADCAST_JOIN_MEETING,
      payload: {
        meetingResponse,
        attendeeResponse,
        meetingSession,
        mixerAttendeeIds,
        chatToken,
        hasChatAccess
      }
    };

    dispatch(action);
    dispatch(clearModal(AWAITING_KNOCK_APPROVAL));
    dispatch(startProgram());
    dispatch(getCurrentBroadcast());
  };
}

export default joinMeeting;
